import { v } from "convex/values";
import {
  internalControl,
  defineTableWithInternalControl,
} from "../../../lib/shared/validators";

export const workOrderProductStatus = v.union(
  v.literal("pending"),
  v.literal("in_progress"),
  v.literal("completed"),
);

export const validatorWorkOrderProduct = v.object({
  workOrderId: v.id("work_orders"),
  productId: v.optional(v.id("products")),

  // Snapshot de informacion.
  name: v.string(),
  description: v.optional(v.string()),
  code: v.optional(v.string()),
  barcode: v.optional(v.string()),
  model: v.optional(v.string()),

  // Datos especificos por orden.
  quantity: v.optional(v.number()),
  unitPrice: v.number(),
  purchasePrice: v.optional(v.number()),
  unit: v.optional(v.string()),

  // Impuestos y descuentos.
  taxRate: v.optional(v.number()),
  taxAmount: v.optional(v.number()),
  isExempt: v.optional(v.boolean()),
  exemptRate: v.optional(v.number()),
  exemptAmount: v.optional(v.number()),
  discountRate: v.optional(v.number()),
  discountAmount: v.optional(v.number()),

  // Calculados.
  subtotal: v.optional(v.number()),
  totalAmount: v.optional(v.number()),

  // Estado y notas.
  status: v.optional(workOrderProductStatus),
  notes: v.optional(v.string()),

  internalControl,
});

export const work_order_products = defineTableWithInternalControl(
  validatorWorkOrderProduct,
)
  .index("by_work_order", ["workOrderId"])
  .index("by_product", ["productId"])
  .index("by_work_order_and_product", ["workOrderId", "productId"])
  .index("by_company_and_work_order", [
    "internalControl.companyId",
    "workOrderId",
  ])
  .index("by_branch_and_work_order", [
    "internalControl.branchId",
    "workOrderId",
  ])
  .index("by_status", ["status"]);